import io from "socket.io-client";
import { getRealTimeServerURL } from "../../config/config";
import { createContext, useEffect, useState, useCallback } from 'react';

export const SocketContext = createContext();

const Socket = props => {

    const [server, setServer] = useState();

    const connectSocket = useCallback(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        const newSocket = io(getRealTimeServerURL(), {
            path: '/rt',
            // Se lee el token en cada (re)conexion para usar la version renovada mas reciente
            auth: (cb) => {
                cb({ token: localStorage.getItem('token') });
            },
            transports: ['websocket', 'polling']
        });

        newSocket.on("connect_error", (err) => {
            console.log("❌ [SOCKET] connect_error:", err.message);
        });

        setServer(newSocket);
        return newSocket;
    }, []);

    // Conectar al montar si ya hay token (ej: refresh de pagina)
    useEffect(() => {
        const socket = connectSocket();
        return () => { if (socket) socket.close(); };
    }, []);

    // Escuchar cambios en el token (login/logout)
    useEffect(() => {
        const handleStorageChange = () => {
            const token = localStorage.getItem('token');
            if (token) {
                // Cerrar conexion anterior si existe
                if (server) server.close();
                connectSocket();
            } else {
                // Logout: desconectar
                if (server) {
                    server.close();
                    setServer(null);
                }
            }
        };

        // Escuchar evento custom que dispara el authState al hacer login/logout
        window.addEventListener('auth-changed', handleStorageChange);
        return () => window.removeEventListener('auth-changed', handleStorageChange);
    }, [server, connectSocket]);

    return(
        <SocketContext.Provider value={server}>
            {props.children}
        </SocketContext.Provider>
    )

}

export default Socket;
